// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 761 ? "d0deef33" : chunkId) + "." + {"87":"bf3c59295c7fad61","761":"ae9fba77c41682f7"}[chunkId] + ".js";
};